import { render, staticRenderFns } from "./WorkPeriodBar.vue?vue&type=template&id=9643c4e4&scoped=true&"
import script from "./WorkPeriodBar.vue?vue&type=script&lang=js&"
export * from "./WorkPeriodBar.vue?vue&type=script&lang=js&"
import style0 from "./WorkPeriodBar.vue?vue&type=style&index=0&id=9643c4e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9643c4e4",
  null
  
)

export default component.exports